var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H4.5C4.13078 3.00002 3.77469 3.13697 3.50063 3.38437C3.45822 3.41928 3.41928 3.45822 3.38437 3.50063C3.13697 3.77469 3.00002 4.13078 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8692 21 20.2253 20.863 20.4994 20.6156C20.5208 20.5984 20.5411 20.5799 20.5603 20.5603C20.5799 20.5413 20.5981 20.521 20.6147 20.4994C20.8627 20.2256 21.0001 19.8694 21 19.5V4.5ZM19.5 18.4406L5.56031 4.5H19.5V18.4406ZM4.5 5.56031L18.4397 19.5H4.5V5.56031Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default ForwardRef;